import { render, staticRenderFns } from "./PendingCampaigns.vue?vue&type=template&id=8ba3c4d6&scoped=true"
import script from "./PendingCampaigns.vue?vue&type=script&lang=ts"
export * from "./PendingCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba3c4d6",
  null
  
)

export default component.exports